import { Component, OnInit, Input } from '@angular/core';
import { CommonConstants } from '../common/utilities/commonConstants';
import { RouteContextProvider } from './../common/services/routeContextProvider.service';
import { SessionHandlerService } from '../common/services/sessionHandler.service';
import { adobe_analytics_service } from '../common/services/adobe_analytics_service';
@Component({
    selector: 'offer-add',
    templateUrl: 'offerAdd.template.html',
    styleUrls: ['offerAdd.style.scss']
})
export class OfferAddComponent implements OnInit {
    @Input() addLocation;
    @Input() public ProdType;
    public travelUrl = '';
    public cyberUrl = '';
    public healthUrl = '';
    public ulipUrl = '';
    public healthRejectUrl: string = '';
    public ulipRejectUrl: string = '';
    public healthUrl4W = '';
    public ulipUrl4W = '';
    public healthRejectUrl4W: string = '';
    public ulipRejectUrl4W: string = '';
    public ProductType: string;
    public ProdTypeSession: string;
    constructor(
        private _sessionHandlerService: SessionHandlerService,
        private _routeContextProvider: RouteContextProvider,
        private _adobe_analytics_service: adobe_analytics_service
    ) {
    }
    ngOnInit() {
        this.ProductType = this.ProdType;
        this.ProdTypeSession = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.InsProductType);
        this.travelUrl = CommonConstants.offerAdds.travelInsuranceAdd;
        this.cyberUrl = CommonConstants.offerAdds.cyberInsuranceAdd;
        // Two wheeler
        this.healthUrl = CommonConstants.offerAdds.healthInsuranceAdd;
        this.ulipUrl = CommonConstants.offerAdds.UlipInsuranceAdd;
        this.ulipRejectUrl = CommonConstants.offerAdds.UlipRejectInsuranceAdd;
        this.healthRejectUrl = CommonConstants.offerAdds.healthRejectInsuranceAdd;
        // Four wheeler
        this.healthUrl4W = CommonConstants.offerAdds.healthInsuranceAdd4W;
        this.ulipUrl4W = CommonConstants.offerAdds.UlipInsuranceAdd4W;
        this.ulipRejectUrl4W = CommonConstants.offerAdds.UlipRejectInsuranceAdd4W;
        this.healthRejectUrl4W = CommonConstants.offerAdds.healthRejectInsuranceAdd4W;
    }
    public analyticsCall(prodCode, prodName, url) {
        this._adobe_analytics_service.crossellProducts('multiTabFailed', prodCode, prodName, prodName, '', '', url);
    }
}
